var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 20.2485C0.75 19.8343 1.08579 19.4985 1.5 19.4985H22.5C22.9142 19.4985 23.25 19.8343 23.25 20.2485C23.25 20.6627 22.9142 20.9985 22.5 20.9985H1.5C1.08579 20.9985 0.75 20.6627 0.75 20.2485Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68934 2.68787C2.97064 2.40657 3.35218 2.24854 3.75 2.24854H12.75C13.1478 2.24854 13.5294 2.40657 13.8107 2.68787C14.092 2.96918 14.25 3.35071 14.25 3.74853V20.2485C14.25 20.6627 13.9142 20.9985 13.5 20.9985C13.0858 20.9985 12.75 20.6627 12.75 20.2485V3.74854H3.75L3.75 20.2485C3.75 20.6627 3.41421 20.9985 3 20.9985C2.58579 20.9985 2.25 20.6627 2.25 20.2485V3.74853C2.25 3.35071 2.40803 2.96918 2.68934 2.68787Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 8.99854C12.75 8.58432 13.0858 8.24854 13.5 8.24854H20.25C20.6478 8.24854 21.0294 8.40657 21.3107 8.68788C21.592 8.96918 21.75 9.35071 21.75 9.74854V20.2485C21.75 20.6627 21.4142 20.9985 21 20.9985C20.5858 20.9985 20.25 20.6627 20.25 20.2485L20.25 9.74854L13.5 9.74854C13.0858 9.74854 12.75 9.41275 12.75 8.99854Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 6.74854C5.25 6.33432 5.58579 5.99854 6 5.99854H9C9.41421 5.99854 9.75 6.33432 9.75 6.74854C9.75 7.16275 9.41421 7.49854 9 7.49854H6C5.58579 7.49854 5.25 7.16275 5.25 6.74854Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 12.7485C6.75 12.3343 7.08579 11.9985 7.5 11.9985H10.5C10.9142 11.9985 11.25 12.3343 11.25 12.7485C11.25 13.1627 10.9142 13.4985 10.5 13.4985H7.5C7.08579 13.4985 6.75 13.1627 6.75 12.7485Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 16.4985C5.25 16.0843 5.58579 15.7485 6 15.7485H9C9.41421 15.7485 9.75 16.0843 9.75 16.4985C9.75 16.9127 9.41421 17.2485 9 17.2485H6C5.58579 17.2485 5.25 16.9127 5.25 16.4985Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 16.4985C15.75 16.0843 16.0858 15.7485 16.5 15.7485H18C18.4142 15.7485 18.75 16.0843 18.75 16.4985C18.75 16.9127 18.4142 17.2485 18 17.2485H16.5C16.0858 17.2485 15.75 16.9127 15.75 16.4985Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 12.7485C15.75 12.3343 16.0858 11.9985 16.5 11.9985H18C18.4142 11.9985 18.75 12.3343 18.75 12.7485C18.75 13.1627 18.4142 13.4985 18 13.4985H16.5C16.0858 13.4985 15.75 13.1627 15.75 12.7485Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.916cf8ea.svg";
export { ForwardRef as ReactComponent };